<div class="d-flex">
  <h1 mat-dialog-title class="text-primary">Locked</h1>
  <mat-icon class="text-primary mt-1 ms-2">lock</mat-icon>
</div>
<div class="d-flex flex-column">
  <div mat-dialog-content>This questionnaire has been locked and cannot be edited.</div>
  <div mat-dialog-content>You can only able to view.</div>
</div>
<div mat-dialog-actions class="d-flex justify-content-end">
  <button mat-button mat-dialog-close class="bg-light-blue text-white" >VIEW</button>
</div>
